let youtubePromise = null;

function loadYoutubeAPI() {
    if (youtubePromise) {
        return youtubePromise;
    }

    youtubePromise = new Promise((resolve) => {
        if (window.YT && window.YT.Player && window.YT.loaded) {
            resolve(window.YT);
            return;
        }

        const previousReady = window.onYouTubeIframeAPIReady;

        window.onYouTubeIframeAPIReady = () => {
            if (previousReady) previousReady();
            resolve(window.YT);
        };

        if (!document.getElementById('iframe_api')) {
            const tag = document.createElement('script');
            tag.src = "https://www.youtube.com/iframe_api";
            tag.id = "iframe_api";
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
        }
    });

    return youtubePromise;
}

function initTabsSections() {
    const tabSections = document.querySelectorAll('.section-tabs');
    if (tabSections.length === 0) {
        return;
    }

    loadYoutubeAPI().then((YT) => {
        tabSections.forEach((section) => {
            initSection(section, YT);
        });
    });
}

function initSection(section, YT) {
    const tabButtons = section.querySelectorAll('.tab-button');
    const videoTopicButtons = section.querySelectorAll('.video-topic-button');
    const tabTopics = section.querySelectorAll('.tab-topics');
    const nextSection = section.nextElementSibling;
    const tabTimeout = 5000;

    let timerRunning = true;
    let currentRunningAnimation = null;
    let activeVideoPlayer = null;

    const observer = new IntersectionObserver((entries) => {
        entries.forEach(entry => {
            if (!entry.isIntersecting) {
                const isAbove = entry.boundingClientRect.top < 0;
                if (isAbove && timerRunning) {
                    stopTabCycle();
                }
            }
        });
    }, { threshold: 0.5 });

    if (nextSection) {
        observer.observe(nextSection);
    }

    let videoPlayerDiv = window.innerWidth < 768
        ? section.querySelector('.tab-topics.active .video-topic.active .video-embed-mobile')
        : section.querySelector('.video-embed-desktop');

    if (!videoPlayerDiv && window.innerWidth < 768) {
        const firstMobile = section.querySelector('.video-embed-mobile');
        if (firstMobile) {
            videoPlayerDiv = firstMobile;
        }
    }

    attachContentToPlayerContainer(videoTopicButtons[0]);

    if (window.innerWidth > 768) {
        if (videoPlayerDiv) {
            createVideoPlayer(videoPlayerDiv);
        }
        activateTab(0);
        cycleTabs(0);
    } else {
        activateTab(0);
        section.classList.add('tab-cycle-stopped');
    }

    addTabListeners();
    initVideoTopicButtons();
    addStopCycleListeners();
    initTopicDescHeightVars();
    handleVideoNavBtns();
    handleVideoListBtns();

    setTimeout(() => {
        updateContentTitle();
    }, 100);

    function animateTabTimer(tabId) {
        const tabTimer = section.querySelector(`.tab-button[data-tab="${tabId}"] .tab-timer`);
        if (!tabTimer) {
            return Promise.resolve();
        }
        const tabTimerProgress = tabTimer.querySelector('.tab-timer-progress');
        if (!tabTimerProgress) {
            return Promise.resolve();
        }

        const animationObject = tabTimerProgress.animate(
            [{ scale: '0 1', opacity: 1 }, { scale: '1 1', opacity: 1 }], { duration: tabTimeout, fill: 'forwards' }
        );

        currentRunningAnimation = animationObject;
        return animationObject.finished;
    }

    function cycleTabs(tabToActivate) {
        const nextTabId = tabToActivate < tabButtons.length - 1 ? tabToActivate + 1 : 0;
        const timerPromise = animateTabTimer(tabToActivate);

        timerPromise.then(() => {
            activateTab(nextTabId);
            const tabTimerProgress = section.querySelector(`.tab-button[data-tab="${tabToActivate}"] .tab-timer-progress`);
            if (tabTimerProgress) {
                tabTimerProgress.animate([{ opacity: 1 }, { opacity: 0 }], { duration: 300, fill: 'forwards' });
            }
            if (timerRunning) {
                cycleTabs(nextTabId);
            }
        }).catch((e) => {
            // Animation cancelled, expected behavior when stopping cycle
        });
    }

    function activateTab(tabId) {
        tabId = String(tabId);
        let firstTopicButton = null;

        videoTopicButtons.forEach((button) => {
            button.classList.remove('active');
        });

        tabTopics.forEach((topic) => {
            if (topic.classList.contains('active')) {
                topic.classList.remove('active');
            }
            if (topic.dataset.tab === tabId) {
                topic.classList.add('active');
                firstTopicButton = topic.querySelector('.video-topic-button');
            }
        });

        tabButtons.forEach((button) => {
            button.classList.toggle('active', button.dataset.tab === tabId);
        });

        if (window.innerWidth < 768) {
            const activeTabBtn = section.querySelector('.tab-button.active');
            if (activeTabBtn) {
                const activeTabBtnContainer = activeTabBtn.closest('li');
                const tabBtnsContainer = section.querySelector('.tab-btns-container');
                if (tabBtnsContainer && activeTabBtnContainer) {
                    tabBtnsContainer.scrollTo({
                        left: activeTabBtnContainer.offsetLeft - 24,
                        behavior: 'smooth',
                        duration: 300,
                    });
                }
            }
        }

        initTopicDescHeightVars();
        if (firstTopicButton) activateTopic(firstTopicButton, true, true);
    }

    function attachContentToPlayerContainer(button) {
        if (!button) {
            return;
        }
        const contentJson = JSON.parse(button.dataset.contentJson);
        const currentPlayerContainer = (window.innerWidth < 768)
            ? section.querySelector('.tab-topics.active .video-topic.active .player-container-mobile')
            : section.querySelector('.player-container-desktop');

        if (!currentPlayerContainer) {
            return;
        }

        currentPlayerContainer.setAttribute('data-content-json', JSON.stringify(contentJson));

        if (contentJson[0].content_type === 'image') {
            currentPlayerContainer.setAttribute('data-media-type', 'image');
        } else {
            currentPlayerContainer.setAttribute('data-media-type', 'video');
        }
    }

    function activateTopic(topicButton, noTransition = false, noScroll = false) {
        if (!topicButton) {
            return;
        }

        videoTopicButtons.forEach((button) => {
            button.closest('.video-topic').classList.toggle('active', button === topicButton);
        });

        activateTopicButton(topicButton, noTransition);

        const contentContainer = (window.innerWidth < 768)
            ? section.querySelector('.tab-topics.active .video-topic.active .player-container-mobile')
            : section.querySelector('.player-container-desktop');

        if (contentContainer) {
            if (topicButton.dataset.contentJson === '[]') {
                contentContainer.classList.add('hidden');
                return;
            } else {
                contentContainer.classList.remove('hidden');
            }
            contentContainer.dataset.activeContentKey = 0;
            attachContentToPlayerContainer(topicButton);
        }

        const contentObj = JSON.parse(topicButton.dataset.contentJson);
        let firstVideoID = getFirstVideoId(contentObj);

        handlePagination();

        if (firstVideoID) {
            if (window.innerWidth >= 768) {
                if (activeVideoPlayer && activeVideoPlayer.cueVideoById) {
                    activeVideoPlayer.cueVideoById(firstVideoID);
                } else {
                    const embed = section.querySelector('.video-embed-desktop');
                    createVideoPlayer(embed);
                }
            } else {
                const mobileContainer = section.querySelector('.tab-topics.active .video-topic.active .player-container-mobile');
                if (mobileContainer) {
                    const embed = mobileContainer.querySelector('.video-embed-mobile');
                    if (activeVideoPlayer && typeof activeVideoPlayer.destroy === 'function') {
                        activeVideoPlayer.destroy();
                    }
                    createVideoPlayer(embed);
                }
            }
        }

        if ((window.innerWidth < 768) && !noScroll) {
            setTimeout(() => {
                const activeTopic = section.querySelector('.tab-topics.active .video-topic.active');
                if (activeTopic) {
                    window.scrollTo({
                        top: activeTopic.offsetTop - 92,
                        behavior: 'smooth',
                        duration: 400,
                    });
                }
            }, 300);
        }

        if (contentObj[0].content_type === 'image') {
            setImageUrl(contentObj[0].url);
        }
    }

    function activateTopicButton(topicButton, noTransition = false) {
        const topic = topicButton.closest('.video-topic');
        const description = topic.querySelector('.video-topic-description');
        if (!description) {
            topicButton.classList.toggle('active');
            return;
        }

        if (noTransition) {
            const originalTransition = topic.style.transition;
            description.style.transition = '0ms all';
            topicButton.classList.toggle('active');
            setTimeout(() => {
                description.style.transition = originalTransition;
            }, 10);
        } else {
            topicButton.classList.toggle('active');
        }
    }

    function stopTabCycle() {
        timerRunning = false;
        if (currentRunningAnimation) {
            currentRunningAnimation.cancel();
        }
        section.classList.add('tab-cycle-stopped');
    }

    function addStopCycleListeners() {
        section.querySelectorAll('a, button').forEach((element) => {
            element.addEventListener('click', stopTabCycle);
        });
    }

    function addTabListeners() {
        tabButtons.forEach((button) => {
            button.addEventListener('click', () => {
                const tabId = button.dataset.tab;
                activateTab(tabId);
            });
        });
    }

    function createVideoPlayer(embedContainer) {
        if (!embedContainer) {
            return;
        }
        const playerContainer = embedContainer.closest('.player-container');
        if (!playerContainer) {
            return;
        }

        const activeContentKey = parseInt(playerContainer.dataset.activeContentKey || 0);
        const contentObject = JSON.parse(playerContainer.dataset.contentJson || '[]');
        if (contentObject.length === 0) {
            return;
        }

        let videoId = null;
        if (contentObject[activeContentKey] && contentObject[activeContentKey].content_type === 'video') {
            videoId = contentObject[activeContentKey].youtube_id;
        } else {
            const firstVideo = contentObject.find(item => item.content_type === 'video');
            if (firstVideo) {
                videoId = firstVideo.youtube_id;
            }
        }

        if (!videoId) {
            return;
        }

        activeVideoPlayer = new YT.Player(embedContainer.id, {
            height: '100%',
            width: '100%',
            videoId: videoId,
            playerVars: {
                autoplay: 0,
                enablejsapi: 1,
                rel: 0,
                origin: window.location.origin
            },
            events: {
                'onReady': function (event) {
                    handlePagination();
                },
                'onStateChange': function (event) {
                    if (event.data === YT.PlayerState.CUED) {
                        updateContentTitle();
                        handlePagination();
                    }
                }
            }
        });
    }

    function initVideoTopicButtons() {
        videoTopicButtons.forEach((button) => {
            button.addEventListener('click', () => activateTopic(button));
        });
    }

    function handlePagination() {
        const currentPlayerContainer = (window.innerWidth < 768)
            ? section.querySelector('.tab-topics.active .video-topic.active .player-container-mobile')
            : section.querySelector('.player-container-desktop');

        if (!currentPlayerContainer) {
            return;
        }
        const paginationDiv = currentPlayerContainer.querySelector('.video-pagination');

        if (paginationDiv) {
            const contentObj = JSON.parse(currentPlayerContainer.dataset.contentJson || '[]');
            const currentContentKey = parseInt(currentPlayerContainer.dataset.activeContentKey || 0);
            const currentParams = (currentContentKey + 1).toString().padStart(2, '0');
            const totalParams = contentObj.length.toString().padStart(2, '0');

            const currentEl = paginationDiv.querySelector('.slider-control-current');
            const totalEl = paginationDiv.querySelector('.slider-control-total');

            if (currentEl && totalEl) {
                currentEl.textContent = currentParams;
                totalEl.textContent = totalParams;
            }
        }
    }

    function handleVideoNavBtns() {
        const buttons = section.querySelectorAll('.video-btn-next, .video-btn-prev');
        buttons.forEach((btn) => {
            btn.addEventListener('click', () => {
                let currentPlayerContainer = (window.innerWidth < 768)
                    ? section.querySelector('.tab-topics.active .video-topic.active .player-container-mobile')
                    : section.querySelector('.player-container-desktop');

                if (activeVideoPlayer && typeof activeVideoPlayer.getPlayerState === 'function') {
                    if (activeVideoPlayer.getPlayerState() === 1) {
                        activeVideoPlayer.pauseVideo();
                    }
                }

                const contentObj = JSON.parse(currentPlayerContainer.dataset.contentJson);
                const currentContentKey = parseInt(currentPlayerContainer.dataset.activeContentKey || 0);
                let newIndex = (btn.classList.contains('video-btn-next')) ? (currentContentKey + 1) % contentObj.length : (currentContentKey - 1 + contentObj.length) % contentObj.length;

                currentPlayerContainer.dataset.activeContentKey = newIndex;

                if (contentObj[newIndex].content_type === 'video') {
                    currentPlayerContainer.setAttribute('data-media-type', 'video');
                    if (activeVideoPlayer && activeVideoPlayer.cueVideoById) {
                        activeVideoPlayer.cueVideoById(contentObj[newIndex].youtube_id);
                    }
                } else {
                    setImageUrl(contentObj[newIndex].url);
                }
            });
        });
    }

    function updateContentTitle() {
        let currentPlayerContainer = (window.innerWidth < 768)
            ? section.querySelector('.tab-topics.active .video-topic.active .player-container-mobile')
            : section.querySelector('.player-container-desktop');

        if (!currentPlayerContainer) {
            return;
        }
        let title = '';

        if (currentPlayerContainer.dataset.mediaType === 'video' && activeVideoPlayer && activeVideoPlayer.getVideoData) {
            const data = activeVideoPlayer.getVideoData();
            if (data) {
                title = data.title;
            }
        } else {
            const contentObj = JSON.parse(currentPlayerContainer.dataset.contentJson || '[]');
            const currentContentKey = currentPlayerContainer.dataset.activeContentKey || 0;
            if (contentObj[currentContentKey]) {
                title = contentObj[currentContentKey].title;
            }
        }

        const titleDiv = currentPlayerContainer.querySelector('.video-title');
        if (titleDiv) {
            titleDiv.innerHTML = title || '';
        }
    }

    function initTopicDescHeightVars() {
        const topic = section.querySelector('.tab-topics.active');
        if (!topic) {
            return;
        }
        const descriptions = topic.querySelectorAll('.video-topic-description');
        descriptions.forEach((description) => {
            description.style.setProperty('--scrollheight', (description.scrollHeight + 100) + 'px');
        });
    }

    function setImageUrl(imageUrl) {
        let currentPlayerContainer = (window.innerWidth < 768)
            ? section.querySelector('.tab-topics.active .video-topic.active .player-container-mobile')
            : section.querySelector('.player-container-desktop');

        if (!currentPlayerContainer) {
            return;
        }
        const image = currentPlayerContainer.querySelector('.image-container img');
        if (image) {
            image.src = imageUrl;
        }

        currentPlayerContainer.setAttribute('data-media-type', 'image');
        updateContentTitle();
        handlePagination();
    }

    function handleVideoListBtns() {
        const videoListBtns = section.querySelectorAll('.video-list-btn');
        const currentPlayerContainer = (window.innerWidth < 768)
            ? section.querySelector('.tab-topics.active .video-topic.active .player-container-mobile')
            : section.querySelector('.player-container-desktop');

        if (!currentPlayerContainer) {
            return;
        }

        videoListBtns.forEach((btn) => {
            btn.addEventListener('click', () => {
                const contentObj = JSON.parse(section.querySelector('.player-container-desktop').dataset.contentJson);
                const contentKey = btn.dataset.contentKey;
                const content = contentObj[contentKey];

                if (content.content_type === 'video') {
                    if (activeVideoPlayer) {
                        activeVideoPlayer.cueVideoById(content.youtube_id);
                    }
                    currentPlayerContainer.setAttribute('data-media-type', 'video');
                } else {
                    setImageUrl(content.url);
                }

                currentPlayerContainer.dataset.activeContentKey = contentKey;
                handlePagination();
                updateContentTitle();
            });
        });
    }

    function getFirstVideoId(contentObject) {
        if (!contentObject) {
            return null;
        }
        for (let i = 0; i < contentObject.length; i++) {
            if (contentObject[i].content_type === 'video') {
                return contentObject[i].youtube_id;
            }
        }
        return null;
    }
}

export default initTabsSections;